import Vue from 'vue'
import App from './App.vue'
import router from './router'
import http from './utils/request.js'
// 导入vant组件库
import Vant from "vant";
// vant Css样式
import "vant/lib/index.css";
// 公共样式
import "./assets/css/public.less"
// 公共过滤方法
import '@/utils/setVant';

import NavTitle from './components/common/nav-title.vue';
Vue.component('NavTitle', NavTitle);

// 引入wxJSDK
// import wx from 'weixin-js-sdk';
// Vue.prototype.$wx = wx;

// 引入vconsole插件
// import Vconsole from 'vconsole'
// var vConsole = new Vconsole();
// console.log(vConsole)

// 全局导入组件库
Vue.use(Vant);
Vue.prototype.$http = http
Vue.prototype.$Html5Qrcode = window.Html5Qrcode
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
